import { Component, Output, EventEmitter, Input } from '@angular/core';

import { snFadeIn, snFadeOut, snDetailExpand } from '@lib/common/animations';
import { SnTableBaseComponent } from '@lib/core';
import { SnActionConfig } from '@lib/ui/actions';

import { FsLprFleetRead } from '../../api';
import { PlateReviewService } from '../../services';

@Component({
  selector: 'fs-fleet-query-table',
  templateUrl: './fleet-query-table.component.html',
  styleUrls: ['./fleet-query-table.component.scss'],
  animations: [snFadeIn, snFadeOut, snDetailExpand],
})
export class FleetQueryTableComponent extends SnTableBaseComponent<FsLprFleetRead> {
  @Output() public plateClicked = new EventEmitter<FsLprFleetRead>();

  @Input() public selectedPlate: FsLprFleetRead | null = null;
  @Input() public items: FsLprFleetRead[];
  @Input() public columns: string[];
  @Input() public actions: SnActionConfig<FsLprFleetRead>[];
  @Input() public getPlateWarningInfoTooltip: (plate: FsLprFleetRead) => string | null;
  @Input() public isReviewingPlates: boolean = false;

  constructor(private readonly _plateReviewService: PlateReviewService) {
    super();
  }

  public trackBy(index: number, item: FsLprFleetRead): any {
    return item.id;
  }

  /**
   *
   * @param clickedPlate The plate that was clicked
   * Emits the plateClicked event with the clicked plate
   */
  public onPlateClick(clickedPlate: FsLprFleetRead): void {
    this.selectedPlate = clickedPlate;
    this.plateClicked.emit(clickedPlate);
  }

  public isMarkedForReview(plate: FsLprFleetRead): boolean {
    return this._plateReviewService.isMarkedForReview(plate.id);
  }
}
